
import confirmationDialog from "./confirmation-dialog.vue";
import { mapState, mapActions } from "vuex";
export default {
  components: { confirmationDialog },
  props: {
    item: {
      type: Object,
      required: true
    },
    dialog: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState("menu", ["combosList"]),

    combosToBeRemoved() {
      let combos = [];

      if (this.item?.variants?.items?.length > 0) {
        this.item.variants.items.forEach((variant) => {
          const matchingCombos = this.combosList?.filter((combo) =>
            combo.combo_items.some((item) => item.comboable_id === variant.id)
          );
          combos = combos.concat(matchingCombos);
        });
      } else {
        combos = this.combosList?.filter((combo) =>
          combo.combo_items.some((item) => item.comboable_id === this.item.id)
        );
      }

      return [...new Set(combos)];
    }
  }
};
